import {useLayoutEffect, useRef, useState, memo, useEffect} from "react";
import { loadModules } from "esri-loader";
import { useEsri } from "../EsriContext";
import Card from "../components/Card";
import Collapse from "../components/Collapse";
import { ArrowIcon } from "../components/Icons";

const LegendCard = memo(({ position, customClass }) => {
  const containerRef = useRef();
  const { esriLoader } = useEsri();
  const [isOpen, setIsOpen] = useState(false);

  useLayoutEffect(() => {
    if (!esriLoader) return;
    const modulesToLoad = ["esri/widgets/Legend"];
    loadModules(modulesToLoad).then(([Legend]) => {
      new Legend({
        view: esriLoader.view,
        container: containerRef.current,
      });

    });
  }, [esriLoader]);

  useEffect(() => {
    setTimeout(() => {
      document.querySelectorAll(".esri-legend__service").forEach((el) => {
        el.removeAttribute("tabindex");
      });
    }, 500);
  })


  const toggle = () => setIsOpen(!isOpen);

  return (
    <Card
      containerStyle={`${position} ${customClass}`}
      bodyClassNames="px-1 px-1"
      testId="legend"
    >
      <button
        className="flex flex-row justify-between cursor-pointer py-1 px-3"
        style={{ width: "22.5rem" }}
        onClick={toggle}
      >
        <div className="flex text-start font-bold">
          <h2 className="font-bold text-xl mt-2">Legend</h2>
        </div>

        <div className="w-1/5">
          <ArrowIcon />
        </div>
      </button>
      <Collapse isOpen={isOpen}>
        <section
          data-testid="legend-test"
          className="space-y-2 h-56 min-w-full overflow-auto my-1"
          tabIndex={0}
        >
          <div className="esri-layer-legend" ref={containerRef}></div>
        </section>
      </Collapse>
    </Card>
  );
});

export default LegendCard;
